export interface WindowReloadModalState {
    onReload: () => void | Promise<void>;
    loading?: boolean | Ref<boolean> | ComputedRef<boolean>;
    disabled?: boolean | Ref<boolean> | ComputedRef<boolean>;
    tooltip?: string;
}

const reloadStates = ref<Map<string, WindowReloadModalState>>(new Map<string, WindowReloadModalState>());

export function useWindowReloadModal(windowId?: string) {
    return computed(() => {
        if (windowId) {
            return reloadStates.value.get(windowId) || null;
        }
        return null;
    });
}

export function registerWindowReloadModal(state: WindowReloadModalState, windowId: string) {
    const newMap = new Map<string, WindowReloadModalState>(reloadStates.value);
    newMap.set(windowId, state);
    reloadStates.value = newMap;
}

export function unregisterWindowReloadModal(windowId: string) {
    const newMap = new Map<string, WindowReloadModalState>(reloadStates.value);
    newMap.delete(windowId);
    reloadStates.value = newMap;
}
